import { Participant, QueueCustomer, QueueUser } from "@/types/fb-type";
import { ShoppingCart } from "lucide-react";
import { ParticipantList } from "../facebook/ParticipantList";
export interface CustomerWatingListProps {
    participants: QueueCustomer[];
    onDropProduct?: (customer: QueueCustomer, productId: string, variantId: string) => void;
    activeId?: string;
    onSelect: (p: QueueCustomer) => void;
    onReplyComment?: (commentId: string) => void;
}

export function CustomerWaitingList({ participants, activeId, onSelect, onDropProduct, onReplyComment }: CustomerWatingListProps) {
    if (participants.length > 0) {
        return (<ParticipantList participants={participants} activeId={activeId} onSelect={onSelect} onDropProduct={onDropProduct} onReplyComment={onReplyComment} />);
    }

    return (<>
        <div className="p-6 text-center text-gray-500">
            <div className="mb-4 flex justify-center">
                <ShoppingCart size={48} />
            </div>
            <h3 className="text-lg font-medium mb-2">
                No customers waiting
            </h3>
            <p className="text-sm">
                Customers in the waiting list will appear here
            </p>
        </div>
    </>);
}